<template>
  <ProlongationLayout
    v-if="prolongationModal.profileShort"
    :profile-short="prolongationModal.profileShort"
    :days-left="prolongationModal.daysLeft"
    @close="prolongationModal.close"
  >
    <template #heading>
      <div
        class="text-headline6 font-semibold text-center mb-2"
        data-test-id="suspended_title"
        v-html="t('suspended', { tier: prolongationModal.tierName })"
      ></div>
    </template>
    <template #description>
      <div
        class="text-tag font-medium color-gray-1 text-center mb-6"
        data-test-id="suspended_subtitle"
      >
        {{ t('wouldYouLikeToTakeCancelled') }}
      </div>
    </template>
    <template #button-action>
      <button
        class="btn btn-block btn-send"
        data-test-id="suspended_reactivate_btn"
        @click="self.unsuspendSubscription()"
      >
        {{ t('reactivate') }}
      </button>
    </template>
  </ProlongationLayout>
</template>
<script lang="ts" setup>
import { PropType, reactive } from 'vue';

import ProlongationLayout from '@/components/prolongation-modal/components/prolongation-layout/ProlongationLayout.vue';
import { useSelf } from '@/components/prolongation-modal/components/prolongation-suspended-modal/hooks/use-self/use-self';
import { PaymentStateSubscription } from '@/pages/payment/store/payment-state';
import { useI18n } from '@/services/i18n';

import { messages } from './i18n';

const props = defineProps({
  subscription: {
    type: Object as PropType<PaymentStateSubscription>,
    required: true,
  },
});

const emit = defineEmits(['close']);

const { t } = useI18n({ messages });

const self = reactive(
  useSelf({
    subscription: props.subscription,
    close() {
      emit('close');
    },
  }),
);
const prolongationModal = reactive(self.prolongationModal);

self.init();
</script>

<style scoped></style>
